import { RefObject, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { UpperBracket } from "../../interfaces/api/UpperBracket";
import { EpiId } from "../../shared/enums/LinkEpiId";
import { ProductType } from "../../shared/enums/ProductType";
import { productHelper } from "../../shared/helpers/productHelper";
import { useEpiserverLink } from "../../store/hooks/useEpiServerLink";
import { useMarket } from "../../store/hooks/useMarket";
import ListDesktop from "../shared/ListTable/ListDesktop";
import ListItem from "../shared/ListTable/ListItem";
import ListItemImage from "../shared/ListTable/ListItemImage";
import ListMobile from "../shared/ListTable/ListMobile";
import ListRow from "../shared/ListTable/ListRow";
import ListTable from "../shared/ListTable/ListTable";
import ProductSeperator from "./ProductSeperator";

const DIRECT_MOUNT = "direct-mount";

interface UpperBracketsProps {
  onChange(upperBracket: UpperBracket): void;
  refUpperBrackets: RefObject<HTMLDivElement>;
  selectedUpperBracket: UpperBracket;
  upperBrackets: UpperBracket[];
}

const OnlyDirectMount = (upperBracket: UpperBracket) =>
  upperBracket.name.toLowerCase().startsWith(DIRECT_MOUNT);

const ExceptDirectMount = (upperBracket: UpperBracket) =>
  !upperBracket.name.toLowerCase().startsWith(DIRECT_MOUNT);

const UpperBrackets = ({
  onChange,
  refUpperBrackets,
  selectedUpperBracket,
  upperBrackets,
}: UpperBracketsProps) => {
  const { t } = useTranslation(["machinefixings"]);
  const market = useMarket();
  // const episerverLinks = useEpiserverLink();
  // const [episerverUrl, setEpiserverUrl] = useState<string>("");
  const [sortedUpperBrackets, setSortedUpperBrackets] = useState<
    UpperBracket[]
  >([]);

  //   useEffect(() => {
  //       if (episerverLinks && upperBrackets && upperBrackets.length > 0) {
  //         const url = `${process.env.REACT_APP_URLPATH}${episerverLinks[upperBrackets[0].epiId]
  //         }`;
  //           setEpiserverUrl(url);
  //       }
  // }, [episerverLinks]);

  useEffect(() => {
    if (upperBrackets.length > 0) {
      const directMountupperBrackets = upperBrackets.filter(OnlyDirectMount);
      const exceptDirectMountBrackets = upperBrackets.filter(ExceptDirectMount);

      setSortedUpperBrackets(
        directMountupperBrackets.concat(exceptDirectMountBrackets)
      );
    }
  }, [upperBrackets]);

  if (!upperBrackets || upperBrackets.length === 0) {
    return <></>;
  }

  const isSelected = (upperBracketId: number): boolean => {
    if (!selectedUpperBracket) {
      return false;
    }

    return selectedUpperBracket.id === upperBracketId;
  };

  return (
    <div ref={refUpperBrackets}>
      <ProductSeperator />
      <h3>
        {t("chooseattachment")}
        <sup>*</sup>
      </h3>
      <ListTable>
        {sortedUpperBrackets.map((upperBracket) => {
          const productData = productHelper.getProductData({
            market,
            product: upperBracket,
            productType: ProductType.UpperBrackets,
            t,
          });

          return (
            <ListRow
              key={upperBracket.id}
              isSelected={isSelected(upperBracket.id)}
              identifier={upperBracket.id.toString()}
              object={upperBracket}
              onChange={(object) => {
                onChange(object as UpperBracket);
              }}
            >
              <>
                <ListDesktop
                  readMeText=""
                  readMeUrl=""
                >
                  <ListItemImage  product={productData} />
                  <ListItem
                    label={productData.nameLabel}
                    minWidth="110px"
                    value={productData.name}
                  />
                  {productData.properties.map((property, index) => {
                    return (
                      <ListItem
                        key={`property-${index}`}
                        label={property.label}
                        minWidth="110px"
                        value={property.text}
                      />
                    );
                  })}
                </ListDesktop>
              </>
              <ListMobile
                content=""
                imageLink={productData.imageLink}
                isSelected={isSelected(upperBracket.id)}
                object={upperBracket}
                onChange={(object) => {
                  onChange(object as UpperBracket);
                }}
                preContent={productData.nameLabel}
                readMeText=""
                readMeUrl=""
                title={productData.name}
              />
            </ListRow>
          );
        })}
      </ListTable>
    </div>
  );
};
export default UpperBrackets;
